import { StreamHandler } from "./stream.handler";
import { SubscribeRaffleProgress, UpdateRaffleProgress } from "@/types";
import type { RaffleProgressSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeRaffles } from "@/stores/derive";

/**
 * `raffle_progress` — the raffle-specific per-player stream: the player's ticket total and the
 * progress on each task. Feeds `raffleProgressById`; the assembled `raffles` view is re-derived on
 * change.
 *
 * Per-player, unlike the pool/pot streams: every viewer sees different numbers. Everything
 * structural about a raffle (tasks, prizes, draw time, winners) rides `campaigns`.
 *
 * On legacy-transport casinos the counts trail play by a few seconds — nothing here (or in the
 * components) may imply sub-second accuracy.
 */
export class RaffleProgressHandler extends StreamHandler<
  RaffleProgressSchema[]
> {
  protected readonly subscribeType = SubscribeRaffleProgress;
  protected readonly updateType = UpdateRaffleProgress;

  protected isBusy(): boolean {
    const s = useAppStore.getState().raffleProgressStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setRaffleProgressLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setRaffleProgressSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearRaffleProgress();
    recomputeRaffles();
  }
  protected apply(data: RaffleProgressSchema[]): void {
    useAppStore.getState().setRaffleProgress(data);
    recomputeRaffles();
  }
}

export const raffleProgressHandler = new RaffleProgressHandler();
